import { Injectable } from '@angular/core';
import {
  ConnectedIssueDto,
  IssueType,
  ValueType,
  PreviewConnectedIssueDto,
  ResourceProfileDto,
  SubmitConnectedIssueDto,
} from '@server-models';
import { FormGroup } from '@angular/forms';
import { SharedIssueStereotypeBaseService } from './stereotype/shared-issue-stereotype-base.service';
import { TCurrentIssueDto } from '../types/issue-dto.type';
import { ILocalIssueDetailData } from '../interfaces/local-issue-detail-data.interface';
import { IAdditionalDetails } from '../interfaces/additional-details.interface';
import { IConnectedConsumptionInput } from '../interfaces/connected-consumption.interface';

@Injectable({ providedIn: 'root' })
export class SharedIssueConnectedService extends SharedIssueStereotypeBaseService {
  override formatReadDetailData(issueDto: TCurrentIssueDto, issueType: IssueType): ILocalIssueDetailData {
    return {
      ...this.formatBaseReadDetailData(issueDto, issueType),
      additionalDetails: this.getAdditionalFormattedData(issueDto as ConnectedIssueDto),
    };
  }

  prepareFormIssueDto(
    form: FormGroup,
    preview: PreviewConnectedIssueDto,
    resourceDto?: ResourceProfileDto,
  ): SubmitConnectedIssueDto {
    const stereotype = preview.issueStereotype;
    const resource = form.get('Resource')?.value ?? resourceDto;
    const consumptions: IConnectedConsumptionInput[] = form.get('Consumptions')?.value ?? [];
    return {
      title: preview.name,
      tenantId: stereotype?.tenantId,
      stereotypeId: stereotype?.stereotypeId,
      stereotypeRowVersion: stereotype?.rowVersion,
      customPropertyValues: this.getCustomPropertyValues(form),
      resource,
      consumptions: consumptions
        .filter((item) => item.value !== null && item.value !== undefined && String(item.value).trim() !== '')
        .map((item) => {
          const numeric = preview.consumptionCodes?.some(
            (code) => code.consumptionCodeId === item.consumptionCodeId && code.valueType === ValueType.Integer,
          );
          const value = String(item.value);
          return { consumptionCodeId: item.consumptionCodeId, value: numeric ? value.trim().replace(',', '.') : value };
        }),
    };
  }

  getAdditionalFormattedData(issueDto: ConnectedIssueDto): Partial<IAdditionalDetails> {
    return { resource: issueDto.resource, consumptions: issueDto.consumptions ?? undefined };
  }
}
